module.exports = __webpack_public_path__ + "static/screen-plans-list-clean.f4a37201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stronglist/screen-plans-list-clean.jpg
// module id = 384
// module chunks = 212420072151734